enum ChannelPartnerOraganizationRole {
  Admin = 'Admin',
  Member = 'Member',
}

export default ChannelPartnerOraganizationRole;
